/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { state } from '@/cart/lib/state';
import { CartModel } from '@/cart/data/models';
import { getCustomerCartPayload, getGuestCartPayload } from '@/cart/api';
import { events } from '@adobe-commerce/event-bus';

export const refreshCart = async (): Promise<CartModel | null> => {
  const payload = state.authenticated
    ? await getCustomerCartPayload()
    : await getGuestCartPayload();

  events.emit('cart/data', payload);

  return payload;
};
